import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Services from '../views/Services.vue'
import Blog from '../views/Blog.vue'
import BlogPost from '../views/BlogPost.vue'
import Contact from '../views/Contact.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/services',
    name: 'Services',
    component: Services
  },
  {
    path: '/blog',
    name: 'Blog',
    component: Blog
  },
  {
    path: '/blog/:id',
    name: 'BlogPost',
    component: BlogPost
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Global navigation guards for progress bar
router.beforeEach((to, from, next) => {
  // Emit event to start progress bar
  window.dispatchEvent(new CustomEvent('progress-start'))
  next()
})

router.afterEach(() => {
  // Emit event to finish progress bar
  window.dispatchEvent(new CustomEvent('progress-finish'))
})

router.onError(() => {
  // Emit event to fail progress bar
  window.dispatchEvent(new CustomEvent('progress-fail'))
})

export default router
